var $87bbc6bd6a045cd5$exports = {};
$87bbc6bd6a045cd5$exports = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Tryk p\xe5 Slet for at fjerne tag.`
};


export {$87bbc6bd6a045cd5$exports as default};
//# sourceMappingURL=da-DK.mjs.map
